//#region src/utils/keyboard.ts
const ACTION_KEY_DEFAULT = "Ctrl";
function isAppleDevice() {
	return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
}

//#endregion
export { isAppleDevice as n, ACTION_KEY_DEFAULT as t };
//# sourceMappingURL=keyboard-BkSdCzTU.js.map